import { useEffect } from 'react';

// The widget is an external script billed per request and meant for administrators only.
// It has no unload API, so leaving the admin area reloads the page to drop it.
const SCRIPT_ID = 'support-widget';
const SCRIPT_SRC = 'https://ias-control.ru/support-widget.js';

export default function useSupportWidget(enabled) {
	useEffect(() => {
		const loaded = document.getElementById(SCRIPT_ID);
		if (!enabled) {
			if (loaded) window.location.reload();
			return;
		}
		if (loaded) return;
		const script = document.createElement('script');
		script.id = SCRIPT_ID;
		script.src = SCRIPT_SRC;
		script.async = true;
		script.dataset.position = 'bottom-right';
		document.body.appendChild(script);
	}, [enabled]);
}
